import { useCallback, useState } from "react";
import { getWorkOrder } from "../api/WorkOrders";
import { useWorkOrderStore } from "../store/wo-order";
import { ApiResponse } from "../models/api/ApiResponse";
import { processError } from "../util/ApiHelper";

/**
 * Fetches the work order and updates the cache
 * @param woNumber
 * @returns isLoading, trigger
 */

const inFlight: Record<string, Promise<ApiResponse>> = {};

export default function useGetWorkOrder() {
  const [isLoading, setIsLoading] = useState(false);
  const addUpdateWorkOrder = useWorkOrderStore(
    (state) => state.addUpdateWorkOrder
  );

  const trigger = useCallback(
    async (woNumber: string) => {
      setIsLoading(true);
      if (!(woNumber in inFlight))
        //make the api call if it is not already in flight
        inFlight[woNumber] = getWorkOrder({
          woNumber: woNumber,
          resources: true,
          appName: "Mobile",
          translations: true,
          equipmentMaster: true,
          permits: true,
          comment: true,
          events: true,
          inspectionDefinition: false,
          labor: true,
          instruction: true,
        });

      try {
        const response = await inFlight[woNumber];
        if (response.status === 200) {
          addUpdateWorkOrder(response.data);
        }
        return response;
      } catch (e) {
        console.error("useGetWorkOrder error:", e);
        return { isError: true, status: 0, data: processError(e) } as ApiResponse;
      } finally {
        setIsLoading(false);
        delete inFlight[woNumber]; // Always clean up, even on error
      }
    },
    [addUpdateWorkOrder]
  );

  return { trigger, isLoading };
}
